module.exports = require('./helpers/bundle-url').getBundleURL('bVFEr') + "logo.7718c6df.svg";